import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import { Collapse, Card } from "antd";
import CompatibleList from "../../common/compatible-list";
import { toDateString, toSetString, toCaseDetailLink } from "../../../helpers/converters";
import { isArray } from "lodash";

const RelatedCases = props => {
  const patnum = props.data.grant_number;
  const queryPTAB = {
    "patent.patent_number": patnum,
    sort: "-filing_date"
  };
  const queryLitigation = {
    patents: patnum,
    sort: "-filed_date"
  };
  const toIndustryText = v =>
    v
      ? {
          T: "High-Tech",
          M: "Medical",
          O: "Other"
        }[v]
      : v;
  const ptabCols = [
    {
      dataIndex: "case_number",
      title: "Case #",
      width: 150,
      render: toCaseDetailLink
    },
    {
      dataIndex: "filing_date",
      title: "Filing Date",
      width: 120,
      render: toDateString
    },
    {
      dataIndex: "up_status_concat",
      title: "Status",
      width: 120
    },
    {
      dataIndex: "petitioners",
      title: "Petitioner",
      width: 200,
      render: toSetString
    },
    {
      dataIndex: "patent_owners",
      title: "Patent Owner",
      width: 200,
      render: toSetString
    },
    {
      dataIndex: "up_industry",
      title: "Industry",
      width: 80,
      render: toIndustryText
    },
    {
      dataIndex: "up_po_type",
      title: "P.O. Entity Type",
      width: 170
    }
  ];
  const litigationCols = [
    {
      title: "Case Number",
      dataIndex: "case_no",
      key: "case_no",
      width: 160,
      render: (caseNum, record) => <Link to={`/litigation/${record.court}/case/${caseNum}`}>{caseNum}</Link>
    },
    {
      title: "Filing Date",
      dataIndex: "filed_date",
      key: "filed_date",
      width: 140,
      render: toDateString
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 100
    },
    {
      title: "Court",
      dataIndex: "court",
      key: "court",
      width: 300
    },
    {
      title: "Plaintiff",
      dataIndex: "plaintiff",
      key: "plaintiff",
      width: 200,
      render: toSetString
    },
    {
      title: "Defendant",
      dataIndex: "defendant",
      key: "defendant",
      width: 200,
      render: toSetString
    },
    {
      title: "Cause of Action",
      dataIndex: "cause_of_action",
      key: "cause_of_action",
      width: 150,
      render: val => (isArray(val) ? toSetString(val) : val)
    },
    {
      title: "Entity Type",
      dataIndex: "entity_type",
      key: "entity_type",
      width: 250
    },
    {
      title: "Industry",
      dataIndex: "industry",
      key: "industry",
      width: 100,
      render: toIndustryText
    }
  ];
  const { ptab, litigation } = props.data;
  return (
    <Card title="Related Cases" bodyStyle={{ padding: 10 }}>
      <Collapse bordered={false} defaultActiveKey={[ptab && ptab.length ? "ptab" : "", litigation && litigation.length ? "litigation" : ""]}>
        <Collapse.Panel
          header={`PTAB (${ptab ? ptab.length : 0})`}
          key="ptab"
          extra={
            <Link
              to={{
                pathname: "/ptab/caselist",
                query: queryPTAB
              }}
            >
              {"See in PTAB Case List"}
            </Link>
          }
        >
          <CompatibleList columns={ptabCols} dataSource={ptab} rowKey="case_number" size="small" />
        </Collapse.Panel>
        <Collapse.Panel
          header={`Litigation (${litigation ? litigation.length : 0})`}
          key="litigation"
          extra={
            <Link
              to={{
                pathname: "/litigation/caselist",
                query: queryLitigation
              }}
            >
              {"See in Litigation Case List"}
            </Link>
          }
        >
          <CompatibleList columns={litigationCols} dataSource={litigation} rowKey="case_no" size="small" />
        </Collapse.Panel>
      </Collapse>
    </Card>
  );
};
RelatedCases.propTypes = {
  data: PropTypes.object.isRequired
};

export default RelatedCases;
